module.exports = __webpack_public_path__ + "static/media/logo-sos-proenem.fcdf48f0.png";